export interface ISrcSetItem {
  size: 'x1' | 'x2';
  url: string;
}

export interface IImgSrcSets {
  x1: string;
  x2: string;
}

export function prepareSrcSets(listOfSrcSets?: ISrcSetItem[] | null): IImgSrcSets | undefined {
  if (!listOfSrcSets || !listOfSrcSets.length) {
    return undefined;
  }

  return listOfSrcSets.reduce(
    (acc, curr) => ({
      ...acc,
      [curr.size]: curr.url,
    }),
    {} as IImgSrcSets,
  );
}
